var map = {
	"./icons/arrow-left.svg": "9ba7",
	"./icons/date.svg": "39ef",
	"./icons/module-element-angle.svg": "57c4",
	"./icons/share.svg": "b551",
	"./icons/text.svg": "2b59",
	"./icons/tooltip-arrow.svg": "15ca"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bb6e";